export const fetchApi = (...args) => {
    let cusFetch = () => { }

    if (window.authenticatedFetch) {
        cusFetch = window.authenticatedFetch;
    } else {
        cusFetch = fetch;
    }

    return cusFetch(...args);
};